
"use client";

import { Culture } from "@/components/languages/CulturesV2";
import { getLink } from "@/constants";
import menu_data from "@/data/memo-menu-data";
import { AppContext } from "@/contextApi/AppProvider";
import { AppContextType } from "@/interFace/general";
import { resolvePostLoginUrl } from "@/lib/Auth/postLoginRedirect";
import Link from "next/link";
import React, { useContext } from "react";
import { useTranslations } from "next-intl";
import { Translations } from "@/translations";


function MemoMenu() {
  const { locale, currentUser, userInfo } = useContext(
    AppContext
  ) as AppContextType;
  const t = useTranslations("General");
  const homepageItem = menu_data[0];
  const menuItems = currentUser?.uid && homepageItem
    ? [
        homepageItem,
        {
          id: 99,
          hasDropdown: false,
          title: Translations.General.Dashboard,
          link: resolvePostLoginUrl({
            locale,
            defaultWorkspace: userInfo.defaultWorkspace,
            roles: userInfo.roles,
            activeRole: userInfo.activeRole,
          }),
        },
      ]
    : menu_data;

  return (
    <>
      {menuItems?.length &&
        menuItems?.map((item) => (
          <li
            key={item.id}
            className={item.hasDropdown ? "menu-item-has-children mr-15" : ""}
          >
            <Link href={getLink(locale, item.link)} className={item.isBtn ? "e-btn text-decoration-none" : "text-decoration-none"}>
              {" "}
              {item.title ? t(item.title) : ""}{" "}
            </Link>

            {item.hasDropdown === true && (
              <ul className="submenu">
                {item?.submenus?.length &&
                  item?.submenus.map((data, index) => (
                    <li key={index}>
                      <Link
                        href={getLink(locale, data.link)}
                        className={data.isBtn ? "e-btn" : ""}
                      >
                        {" "}
                        {t(data.title)}{" "}
                      </Link>
                    </li>
                  ))}
              </ul>
            )}
          </li>
        ))}
      <li>
        <Culture />
      </li>
    </>
  );
};

export default MemoMenu;
